import React, { useState, useEffect } from 'react';

const ReviewsBulkActions = ({ 
  selectedReviews, 
  onApprove, 
  onReject, 
  onDelete,
  clearSelectedReviews,
  loadReviews
}) => {
  const [bulkAction, setBulkAction] = useState('');

  useEffect(() => {
    if (selectedReviews.length === 0) {
      setBulkAction('');
    }
  }, [selectedReviews]);

  const handleBulkAction = async () => {
    if (!selectedReviews.length) {
      alert('No reviews selected.');
      return;
    }

    if (bulkAction === 'approve') {
      await onApprove();
      clearSelectedReviews();
      setBulkAction('');
    } else if (bulkAction === 'reject') {
      await onReject();
      clearSelectedReviews();
      setBulkAction('');
    } else if (bulkAction === 'delete') {
      if (window.confirm(`Are you sure you want to delete ${selectedReviews.length} review(s)?`)) {
        await onDelete();
        clearSelectedReviews();
        setBulkAction('');
      }
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedReviews.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedReviews.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="approve">Approve</option>
        <option value="reject">Reject</option>
        <option value="delete">Delete</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedReviews.length === 0}
      >
        Apply
      </button>
    </div>
  );
};

export default ReviewsBulkActions; 